<script setup lang="ts" generic="T extends BaseProps<any>">
import type { defineActions, defineState } from "../common";
import { Buttons } from "../icons";
import type { BaseProps } from "../props";

const props = defineProps<{
    state: ReturnType<typeof defineState>;
    actions: ReturnType<typeof defineActions>;
}>();
</script>

<template>
    <Buttons.ExtUpdate v-if="props.state.updatable" @click="props.actions.onUpdate" />
    <Buttons.ExtRemove v-if="props.state.removable" @click="props.actions.onDelete" />
</template>
